import React from "react"
import { APPLICATION, useAuth } from "@ncs/ncs-api"

function toBoolean(value: string) {
	return value.trim().toLowerCase() === "true"
}

export const Flag = {
	TARIFFS: toBoolean(import.meta.env.VITE_FLAG_TARIFFS || "false"),
	ECOMM_SERVICE_DISPATCH: toBoolean(import.meta.env.VITE_FLAG_ECOMM_SERVICE_DISPATCH || "false"),
	ECOMM_SERVICE_API: toBoolean(import.meta.env.VITE_FLAG_ECOMM_SERVICE_API || "false"),
	VITE_FLAG_ECOMM_FREIGHT: toBoolean(import.meta.env.VITE_FLAG_ECOMM_FREIGHT || "false"),
	VITE_PDP_DOCUMENTS_FLAG: toBoolean(import.meta.env.VITE_PDP_DOCUMENTS_FLAG || "false"),
}

type FeatureFlagProps = {
	old?: React.ReactElement
	children?: React.ReactElement
	flag: boolean
}

export const isFeatureFlagOn = (flag: boolean) => {
	return flag || !!localStorage["F&F"]
}

export const FeatureFlag: React.FC<FeatureFlagProps> = ({ children, old, flag }) => {
	const { user } = useAuth()
	const component = flag || localStorage["F&F"] ? children : old
	return component ?? null
}

export const useFeatureFlag = (flag: boolean, oldComponent: React.FC, newComponent: React.FC) => {
	const { user } = useAuth()
	return flag || localStorage["F&F"] ? newComponent : oldComponent
}

export const useIsFeatureFlagOn = (flag: boolean) => {
	const { user } = useAuth()
	return flag || localStorage["F&F"]
}
